module.exports = __webpack_public_path__ + "img/CPO.3069f161.png";